module.exports = __webpack_public_path__ + "img/maps.06a7c154.png";